import { Link } from 'react-router-dom';
import { useBreadcrumbs, Breadcrumb } from '@/hooks/useBreadcrumbs';

/**
 * Breadcrumbs component
 * Automatically generates breadcrumb trail based on current route
 */
export function Breadcrumbs() {
  const breadcrumbs = useBreadcrumbs();

  // Don't render if no breadcrumbs or only one (current page with no parents)
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex items-center gap-1 text-sm text-muted-foreground">
        {breadcrumbs.map((crumb, index) => (
          <BreadcrumbItem
            key={crumb.path}
            crumb={crumb}
            isLast={index === breadcrumbs.length - 1}
          />
        ))}
      </ol>
    </nav>
  );
}

interface BreadcrumbItemProps {
  crumb: Breadcrumb;
  isLast: boolean;
}

function BreadcrumbItem({ crumb, isLast }: BreadcrumbItemProps) {
  // Format label: use "Prefix: label" for detail pages, otherwise just label
  const displayLabel = crumb.prefix ? `${crumb.prefix}: ${crumb.label}` : crumb.label;

  return (
    <li className="flex items-center gap-1">
      {crumb.isCurrent ? (
        <span className="text-foreground">{displayLabel}</span>
      ) : (
        <Link
          to={crumb.path}
          className="text-muted-foreground hover:underline"
        >
          {displayLabel}
        </Link>
      )}
      {!isLast && <span className="text-muted-foreground">/</span>}
    </li>
  );
}

export default Breadcrumbs;
